const OPEN = '<current_block>';
const CLOSE = '</current_block>';

/**
 * Splits a stored message into what the user wrote and the trailing `<current_block>…</current_block>`
 * context Blocks Studio appends to every message for the agent. `context` is the text inside the
 * tags (trimmed), or null when the message does not end with one.
 */
export function splitBlockContext(content: string): { text: string; context: string | null } {
  const trimmed = content.trimEnd();
  if (!trimmed.endsWith(CLOSE)) return { text: content, context: null };
  const start = trimmed.lastIndexOf(OPEN);
  // The opening tag must start a line, so text that merely mentions the tag stays as is.
  if (start === -1 || (start > 0 && trimmed[start - 1] !== '\n'))
    return { text: content, context: null };
  return {
    text: trimmed.slice(0, start).trimEnd(),
    context: trimmed.slice(start + OPEN.length, -CLOSE.length).trim(),
  };
}

/** Messages longer than this (characters or lines) start collapsed. */
export const COLLAPSE_CHARS = 1200;
export const COLLAPSE_LINES = 16;

export const isLongMessage = (text: string): boolean =>
  text.length > COLLAPSE_CHARS || text.split('\n').length > COLLAPSE_LINES;
